import * as Sentry from '@sentry/vue'
import SlideAPI from '@/api/slide'

const SET_IS_SLIDE_RENDER_IN_PROGRESS = 'SET_IS_SLIDE_RENDER_IN_PROGRESS'
const _state = {
  isSlideRenderInProgress: false, // Forces Slide component re-render on slideActive change
}

// logic render auto complete slide option

const _getters = {
  isSlideRenderInProgress(state) {
    return state.isSlideRenderInProgress
  },
  slideOptionAutocomplete: (state, getters, rootState) => {
    return rootState.slideActive.slideOptionAutocomplete
  },
}

const _mutations = {
  [SET_IS_SLIDE_RENDER_IN_PROGRESS](state, value) {
    state.isSlideRenderInProgress = value
  },
}

const _actions = {
  setSlideRenderInProgressAction({ commit }, value) {
    commit(SET_IS_SLIDE_RENDER_IN_PROGRESS, value)
  },
  setIsAIIndicatorVisibleAction: async ({ commit }, payload) => {
    try {
      if (!payload.isAIIndicatorVisible) {
        return
      }
      await SlideAPI.setIsAIIndicatorVisible(payload.id)
      commit('updateSlideById', { id: payload.id, isAIIndicatorVisible: false }, { root: true })
    } catch (e) {
      Sentry.captureException(e)
    }
  },

}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions: _actions,
  mutations: _mutations,
}
